<template>
  <div class="c-app">
    <template v-if="first">
      <First />
    </template>
    <template v-else>
      <div class="wrapper d-flex">
        <Sidebar />
        <div class="flex-grow-1 d-flex flex-column min-vh-100">
          <Header class="position-fixed top-0" :style="{ left: show ? '256px' : '0px', right: 0, zIndex: 1050 }"/>
          <div class="body flex-grow-1 px-3" :style="{ marginTop: '120px', marginBottom: '48px', marginLeft: show ? '256px' : '0px', backgroundColor: '#ebedef' }">
            <CContainer fluid class="my-5">
              <transition name="fade">
                <router-view></router-view>
              </transition>
            </CContainer>
          </div>
          
          <Footer class="position-fixed bottom-0" :style="{ left: show ? '256px' : '0px', right: 0, zIndex: 1020, backgroundColor: '#ced2d8' }"/>
          <CNotification />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Sidebar from './Sidebar'
import Header from './Header'
import Footer from './Footer'
import First from './First'
import { CNotification } from '@/views/components/index.js'
import { emitter } from '../../helpers/emitter';

export default {
  name: 'Container',
  components: {
    Sidebar,
    Header,
    Footer,
    First,
    CNotification
  },
  data () {
    return {
      show: true
    }
  },
  computed: {
    first() {
      const first = localStorage.reset_password
      if(first) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    emitter.on('toggle-sidebar', () => {
      this.show = !this.show
    })
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
